import React from 'react';

/*
    Icone piatte (tratto bianco): si usano dentro i pulsanti,
    come nel resto del gioco.
*/
const PATHS = {
    close: <path d="M6 6l12 12M18 6L6 18" />,
    back: <path d="M15 5l-7 7 7 7" />,
    next: <path d="M9 5l7 7-7 7" />,
    plus: <path d="M12 5v14M5 12h14" />,
    check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
    minus: <path d="M6 12h12" />,
    arrow: <path d="M4 12h15M13 6l6 6-6 6" />,
    trash: (
        <>
            <path d="M4 7h16" />
            <path d="M9 7V4.5h6V7" />
            <path d="M6.5 7l1 13h9l1-13" />
            <path d="M10 11v5.5M14 11v5.5" />
        </>
    ),
    lock: (
        <>
            <rect x="5" y="11" width="14" height="9" rx="2" />
            <path d="M8 11V8a4 4 0 0 1 8 0v3" />
        </>
    ),
    gear: (
        <>
            <path d="M10.07 5.27 L10.50 2.52 L13.50 2.52 L13.93 5.27 L15.39 5.88 L17.64 4.23 L19.77 6.36 L18.12 8.61 L18.73 10.07 L21.48 10.50 L21.48 13.50 L18.73 13.93 L18.12 15.39 L19.77 17.64 L17.64 19.77 L15.39 18.12 L13.93 18.73 L13.50 21.48 L10.50 21.48 L10.07 18.73 L8.61 18.12 L6.36 19.77 L4.23 17.64 L5.88 15.39 L5.27 13.93 L2.52 13.50 L2.52 10.50 L5.27 10.07 L5.88 8.61 L4.23 6.36 L6.36 4.23 L8.61 5.88Z" />
            <circle cx="12" cy="12" r="3" />
        </>
    ),
    fullscreen: <path d="M4 9V5a1 1 0 0 1 1-1h4M15 4h4a1 1 0 0 1 1 1v4M20 15v4a1 1 0 0 1-1 1h-4M9 20H5a1 1 0 0 1-1-1v-4" />,
    fullscreenExit: <path d="M9 4v4a1 1 0 0 1-1 1H4M20 9h-4a1 1 0 0 1-1-1V4M15 20v-4a1 1 0 0 1 1-1h4M4 15h4a1 1 0 0 1 1 1v4" />,
};

const FlatIcon = ({ name, size = 24, color = "#fff", weight = 3, className = "" }) => (
    <svg
        className={"flat-icon " + className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={weight}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        style={{ flexShrink: 0 }}
    >
        {PATHS[name]}
    </svg>
);

export default FlatIcon;
